import { Box, Flex, ScrollArea } from "@mantine/core";
import React from "react";
import VSpace from "../../VSpace";
import ValidationTableSettings from "./ValidationTableSettings";

export const DesignSettings: React.FC = () => {
  return (
    // Viktigt: minHeight: 0 gör att barnet får krympa och kan scrolla
    <Flex direction="column" h="100%" style={{ minHeight: 0 }}>
      <ScrollArea style={{ flex: 1, minHeight: 0 }} type="auto" scrollbarSize={8}>
        <ValidationTableSettings />
      </ScrollArea>
    </Flex>
  );
};
